<template>
  <div class="login-step login-step-email">
    <h1 class="step-title">{{ $t('lbl_emp2_SupplierLoginHere') }}</h1>
    
    <form @submit.prevent="handleEnter" autocomplete="on">
      <div class="form-group">
        <div class="input-wrapper">
          <div class="input-container-email" :class="{ 'input-error': emailError }">
            <!-- 浮动标签（有值或错误时显示在边框上方） -->
            <label v-if="emailError || email" class="input-label email-label" :class="{ 'label-error': emailError }">
              {{ $t('lbl_emp2_Email') }} <span class="required">*</span>
            </label>
            <!-- 占位符（无值时显示在输入框内部） -->
            <span v-if="!email && !emailError" class="email-placeholder">
              {{ $t('lbl_emp2_Email') }} <span class="required">*</span>
            </span>
            <input
              :value="email"
              type="email"
              name="email"
              id="email-field"
              autocomplete="email"
              class="form-input-email"
              :class="{ 'input-error': emailError }"
              placeholder=""
              @focus="$emit('clear-email-error')"
              @input="handleInput"
              @keydown.enter.prevent="handleEnter"
            />
          </div>
          <!-- 错误信息 -->
          <div v-if="emailError" class="email-error-message">
            {{ $t('lbl_emp2_InvalidEmail') }}
          </div>
        </div>
      </div>

      <button
        type="submit"
        class="btn-primary"
        :disabled="!isValidEmail || loading"
        t_label="btn_emp2_Continue_EmailStep"
      >
        {{ $t('lbl_emp2_Continue') }}
      </button>
    </form>

    <slot name="divider">
      <div class="divider">
        <span>{{ $t('lbl_emp2_OR') }}</span>
      </div>
    </slot>

    <slot name="alternative-login">
      <div class="alternative-login">
        <button class="btn-secondary" @click="$emit('switch-login', 'username')" t_label="btn_emp2_LoginWithUsername_FromEmail">
          {{ $t('lbl_emp2_LoginWithUsername') }}
        </button>
        <button class="btn-secondary" @click="$emit('switch-login', 'mobile')" t_label="btn_emp2_LoginWithMobile_FromEmail">
          {{ $t('lbl_emp2_LoginWithMobile') }}
        </button>
      </div>
    </slot>

    <!-- SSO 登录暂时隐藏 -->
    <!-- <slot name="sso-login">
      <div class="sso-login">
        <button class="sso-btn wechat" @click="$emit('wechat-login')" title="Login with WeChat">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/wechat_icon.png" alt="WeChat" />
        </button>
        <button class="sso-btn google" @click="$emit('google-login')" title="Login with Google">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/google_icon.png" alt="Google" />
        </button>
        <button class="sso-btn linkedin" @click="$emit('linkedin-login')" title="Login with LinkedIn">
          <img src="https://cdn.adsalecdn.com/EMP/Backend/Images/linkedin_icon.png" alt="LinkedIn" />
        </button>
      </div>
    </slot> -->

    <slot name="become-supplier">
      <div class="become-supplier">
        <span>{{ $t('lbl_emp2_NotASupplierMember') }}</span>
        <a
          href="#"
          @click.prevent="$emit('show-become-supplier')"
          class="supplier-link"
        >
          {{ $t('lbl_emp2_ApplyForMembership') }} →
        </a>
      </div>
    </slot>
  </div>
</template>

<script>
import { validateEmail } from '../Common/utils.js';

export default {
  name: 'EmailStep',
  props: {
    email: {
      type: String,
      default: ''
    },
    emailError: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isValidEmail() {
      // 统一使用 new-login 公共邮箱验证规则
      return validateEmail(this.email);
    }
  },
  methods: {
    handleInput(event) {
      const value = event.target.value.replace(/\s/g, '');
      event.target.value = value;
      this.$emit('update:email', value);
    },
    handleEnter() {
      if (this.loading || !this.isValidEmail) {
        return;
      }
      this.$emit('continue');
    }
  }
};
</script>

<style scoped>
.login-step-email {
  gap: 16px !important;
}

.login-step-email form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.step-title {
  color: rgba(0, 0, 0, 0.80);
  font-size: 28px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 36.40px;
  margin: 0;
  word-wrap: break-word;
}

@media (max-width: 768px) {
  .step-title {
    font-size: 24px;
    line-height: 31.20px;
  }
}

.form-group {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  gap: 16px;
}

.input-wrapper {
  align-self: stretch;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 4px;
  display: flex;
  overflow: visible;
}

.input-container-email {
  width: 100%;
  position: relative;
  overflow: visible;
}

.input-container-email.input-error {
  border-color: #CD1515 !important;
}

.input-label {
  position: absolute;
  left: 12px;
  top: -5px;
  padding: 0 4px;
  background: white;
  display: inline-flex;
  align-items: center;
  color: rgba(0, 0, 0, 0.60);
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.15px;
  white-space: nowrap;
  z-index: 5;
  pointer-events: none;
  margin: 0;
  transform: translateY(0);
}

.input-label.label-error {
  color: #D32F2F;
}

.email-placeholder {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
}

.form-input-email {
  width: 100%;
  padding: 12px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  background: #F8F7FF;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  color: rgba(0, 0, 0, 0.80);
  transition: border-color 0.2s, background 0.2s;
}

.form-input-email:focus {
  outline: none;
  border-color: #7366FF;
  background: white;
}

.form-input-email.input-error {
  border-color: #CD1515 !important;
}

.required {
  color: #CD1515;
  font-size: 14px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  margin-left: 4px;
}

.email-error-message {
  padding-left: 14px;
  padding-right: 14px;
  color: #D32F2F;
  font-size: 12px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  letter-spacing: 0.40px;
  word-wrap: break-word;
}

.btn-primary {
  width: 100%;
  padding: 16px 24px !important;
  background: #7366FF !important;
  color: white !important;
  border: none !important;
  border-radius: 999px !important;
  font-size: 14px !important;
  font-family: 'Inter', sans-serif !important;
  font-weight: 600 !important;
  line-height: 14px !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
}

.btn-primary:hover:not(:disabled) {
  background: #5a4dcc !important;
  color: white !important;
  border: none !important;
}

.btn-primary:disabled {
  opacity: 0.6 !important;
  cursor: not-allowed !important;
  background: #B8B3FF !important;
  color: rgba(255, 255, 255, 0.9) !important;
}

.divider {
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 0;
}

.divider::before,
.divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: rgba(0, 0, 0, 0.10);
}

.divider span {
  color: rgba(0, 0, 0, 0.50);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 14px;
}

.alternative-login {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 0;
  padding: 0;
}

.btn-secondary {
  align-self: stretch;
  height: 42px;
  padding: 0 24px;
  border-radius: 999px;
  outline: 1px rgba(0, 0, 0, 0.60) solid;
  outline-offset: -1px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  display: inline-flex;
  background: white !important;
  background-color: white !important;
  border: none !important;
  cursor: pointer;
  transition: all 0.2s;
  color: rgba(0, 0, 0, 0.80);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 14px;
  word-wrap: break-word;
  box-sizing: border-box;
}

.btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  outline-color: rgba(0, 0, 0, 0.60);
}

.sso-login {
  width: 100%;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.sso-btn {
  flex: 1 1 0;
  height: 74px;
  background: rgba(0, 0, 0, 0.03);
  border: none;
  border-radius: 999px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
}

.sso-btn:hover {
  background: rgba(0, 0, 0, 0.06);
}

.sso-btn svg,
.sso-btn img {
  width: 45px;
  height: 45px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
}

.become-supplier {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.become-supplier span {
  color: rgba(0, 0, 0, 0.60);
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  line-height: 18.2px;
}

.supplier-link {
  color: #7366FF;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  line-height: 18.2px;
  text-decoration: none;
}
</style>

<!-- 全局样式覆盖 -->
<style>
/* 引入共享样式 */
@import '../Common/new-login-shared.css';

.alternative-login .btn-secondary {
  background: white !important;
  background-color: white !important;
  border: none !important;
  color: rgba(0, 0, 0, 0.80) !important;
}

.alternative-login .btn-secondary:hover {
  background: rgba(0, 0, 0, 0.03) !important;
  background-color: rgba(0, 0, 0, 0.03) !important;
  color: rgba(0, 0, 0, 0.80) !important;
}
</style>

